import { Sun, Wrench, Shield, Zap, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Services = () => {
  const services = [
    {
      icon: Sun,
      title: 'Installation de Panneaux Solaires',
      description: 'Installation professionnelle de systèmes photovoltaïques pour particuliers et entreprises. Notre équipe certifiée vous accompagne de l\'<étude de faisabilité jusqu\'<à la mise en service.',
      features: [
        'Étude personnalisée de votre projet',
        'Installation par des techniciens certifiés',
        'Matériel haute qualité garanti',
        'Suivi de production en temps réel',
        'Économies jusqu\'<à 70% sur vos factures'
      ],
      image: 'https://images.unsplash.com/photo-1655300283246-1ef0317a565d?crop=entropy&cs=srgb&fm=jpg&q=85'
    },
    {
      icon: Wrench,
      title: 'Pompes Électromécaniques',
      description: 'Fourniture et installation de pompes électromécaniques adaptées à tous vos besoins : irrigation, drainage, eau potable, et applications industrielles.',
      features: [
        'Large gamme de pompes professionnelles',
        'Conseil technique expert',
        'Installation et mise en service',
        'Maintenance préventive et curative',
        'Pièces de rechange disponibles'
      ],
      image: 'https://images.unsplash.com/photo-1760776066784-dfe3e7b45b3b?crop=entropy&cs=srgb&fm=jpg&q=85'
    },
    {
      icon: Shield,
      title: 'Maintenance & SAV',
      description: 'Service après-vente réactif et maintenance préventive pour garantir la performance optimale de vos équipements. Contrats d\'<entretien sur mesure disponibles.',
      features: [
        'Intervention rapide sous 48h',
        'Contrats de maintenance personnalisés',
        'Diagnostic et réparation',
        'Remplacement de composants',
        'Garantie sur toutes nos interventions'
      ],
      image: 'https://images.unsplash.com/photo-1660330589505-9a433a742a7b?crop=entropy&cs=srgb&fm=jpg&q=85'
    },
    {
      icon: Zap,
      title: 'Conseil Énergétique',
      description: 'Audit énergétique complet et recommandations personnalisées pour optimiser votre consommation et réduire vos coûts énergétiques.',
      features: [
        'Audit énergétique détaillé',
        'Simulation de rentabilité',
        'Accompagnement administratif',
        'Aide aux subventions et crédits d\'<impôt',
        'Suivi post-installation'
      ],
      image: 'https://images.unsplash.com/photo-1720670996646-2f5d69a10ee7?crop=entropy&cs=srgb&fm=jpg&q=85'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <section className="py-20 md:py-32">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <h1 className="font-heading font-semibold text-4xl md:text-5xl tracking-tight mb-4" data-testid="services-page-title">
              Nos Services
            </h1>
            <p className="text-base leading-relaxed text-muted-foreground max-w-2xl mx-auto">
              Des solutions complètes et personnalisées pour tous vos besoins en énergie solaire et équipements électromécaniques
            </p>
          </div>

          <div className="space-y-24">
            {services.map((service, index) => {
              const Icon = service.icon;
              const isEven = index % 2 === 0;
              
              return (
                <div
                  key={index}
                  className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                    isEven ? '' : 'lg:grid-flow-dense'
                  }`}
                  data-testid={`service-item-${index}`}
                >
                  <div className={isEven ? '' : 'lg:col-start-2'}>
                    <div className="aspect-[4/3] rounded-xl overflow-hidden">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>

                  <div className={isEven ? '' : 'lg:col-start-1 lg:row-start-1'}>
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-2xl mb-6">
                      <Icon className="w-8 h-8 text-primary" />
                    </div>
                    <h2 className="font-heading font-semibold text-2xl md:text-3xl tracking-normal mb-4">
                      {service.title}
                    </h2>
                    <p className="text-base leading-relaxed text-muted-foreground mb-6">
                      {service.description}
                    </p>
                    <ul className="space-y-3 mb-8">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <CheckCircle className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                          <span className="text-sm">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <Link
                      to="/contact"
                      className="bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 rounded-full font-medium transition-all hover:scale-105 active:scale-95 shadow-lg shadow-primary/20 inline-flex items-center justify-center"
                      data-testid={`service-cta-${index}`}
                    >
                      Demander un devis
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-primary text-white">
        <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
          <h2 className="font-heading font-semibold text-4xl md:text-5xl tracking-tight mb-6">
            Besoin d'un Service Personnalisé ?
          </h2>
          <p className="text-lg md:text-xl leading-relaxed mb-8 text-white/90">
            Notre équipe d'experts est à votre disposition pour répondre à toutes vos questions
          </p>
          <Link
            to="/contact"
            className="bg-accent text-accent-foreground hover:bg-accent/90 h-12 px-8 rounded-full font-medium transition-all hover:scale-105 active:scale-95 shadow-lg inline-flex items-center justify-center"
            data-testid="services-contact-cta"
          >
            Contactez-nous
          </Link>
        </div>
      </section>
    </div>
  );
};